import React from "react"
import Layout from "../components/Layout"
import SEO from "../components/Seo"
import Hero from "../components/Home/Hero"
import Pilosophy from "../components/Home/Pilosophy"
import WhyWork from "../components/Home/WhyWork"
import WorkTravel from "../components/Home/WorkTravel"
import Testimonios from "../components/Home/Testimonios"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Hero />
    <Pilosophy />
    <WhyWork />
    <WorkTravel />
    <Testimonios />
  </Layout>
)

export default IndexPage
